import * as RadixAccordion from '@radix-ui/react-accordion';
import React from 'react';
import { Box } from '../Box/Box';
import { Flex } from '../Flex/Flex';
import { IconContainer, StyledAccordionRoot, StyledChevron, StyledContent, StyledItem, StyledTrigger } from './Accordion.styled';
/**
 * @public
 */
export function Accordion({
  items,
  itemsState,
  isExternallyControlled,
  onToggle,
  type = 'multiple',
  variation = 'default',
  p = '12px',
  headerDividerColor,
  ...props
}) {
  return items ? React.createElement(StyledAccordionRoot
  // @ts-ignore
  , {
    // @ts-ignore
    type: type,
    defaultValue: itemsState ?? items.map(child => child.value),
    value: isExternallyControlled ? itemsState : undefined,
    collapsible: true,
    variation: variation,
    onValueChange: onToggle,
    "data-testid": 'accordion-root',
    style: {
      isolation: 'isolate'
    }
  }, items.map((child, index) => React.createElement(RadixAccordion.Item, {
    key: child.value,
    asChild: true,
    value: child.value
  }, React.createElement(StyledItem, {
    variation: variation,
    overflow: 'hidden',
    borderRadius: '12px',
    marginBottom: '12px',
    headerBg: child.headerBg,
    "data-testid": `styled-item-${child.value}`,
    headerDividerColor: index > 0 && headerDividerColor
  }, React.createElement(StyledTrigger, {
    ...props,
    p: p,
    variation: variation
  }, React.createElement(Flex, {
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center'
  }, child.headerLabel, child.headerActions ? React.createElement(Box, {
    onClick: e => e.preventDefault()
  }, child.headerActions) : null), React.createElement(IconContainer, {
    margin: 'auto',
    height: '25px'
  }, React.createElement(StyledChevron, {
    className: 'chevron',
    variation: variation
  }))), React.createElement(StyledContent, {
    ...props,
    p: p,
    variation: variation
  }, child.content))))) : null;
}